import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FAQPage from "../pages/faq/page";
import ContactPage from "../pages/contact/page";
import OffertePage from "../pages/offerte/page";
import PrivacybeleidPage from "../pages/privacybeleid/page";
import AlgemeneVoorwaardenPage from "../pages/algemene-voorwaarden/page";
import DienstenPage from "../pages/diensten/page";
import DienstDetailPage from "../pages/diensten/detail/page";
import HoeHetWerktPage from "../pages/hoe-het-werkt/page";
import VoorWiePage from "../pages/voor-wie/page";
import VoorWieDetailPage from "../pages/voor-wie/detail/page";
import OverigPage from "../pages/voor-wie/overig/page";
import InkopenUitChinaPage from "../pages/inkopen-uit-china/page";
import PrivateLabelChinaPage from "../pages/private-label-china/page";
import SourcingServicePage from "../pages/sourcing-service/page";
import BlogPage from "../pages/blog/page";
import GeborduurdeShirtsPage from "../pages/blog/geborduurde-tshirts/page";
import LuxeWandlampenPage from "../pages/blog/luxe-wandlampen/page";
import EvLaadkabelsPage from "../pages/blog/ev-laadkabels/page";
import BedruktePaperBagsPage from "../pages/blog/bedrukte-paper-bags/page";
import EChoppersPage from "../pages/blog/e-choppers/page";
import BedrukteTissuesPage from "../pages/blog/bedrukte-tissues-horeca/page";
import PrivateLabelProductenChinaPage from "../pages/blog/private-label-producten-china/page";
import LageMoqInkopenChinaPage from "../pages/blog/lage-moq-inkopen-china/page";
import GoedkoopInkopenChinaPage from "../pages/goedkoop-inkopen-china/page";
import WieZijnWijPage from "../pages/wie-zijn-wij/page";
import CookiebeleidPage from "../pages/cookiebeleid/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/wie-zijn-wij", element: <WieZijnWijPage /> },
  { path: "/diensten", element: <DienstenPage /> },
  { path: "/diensten/:slug", element: <DienstDetailPage /> },
  { path: "/hoe-het-werkt", element: <HoeHetWerktPage /> },
  { path: "/voor-wie", element: <VoorWiePage /> },
  { path: "/voor-wie/overig", element: <OverigPage /> },
  { path: "/voor-wie/:slug", element: <VoorWieDetailPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/offerte", element: <OffertePage /> },
  { path: "/privacybeleid", element: <PrivacybeleidPage /> },
  { path: "/algemene-voorwaarden", element: <AlgemeneVoorwaardenPage /> },
  { path: "/cookiebeleid", element: <CookiebeleidPage /> },
  { path: "/inkopen-uit-china", element: <InkopenUitChinaPage /> },
  { path: "/goedkoop-inkopen-china", element: <GoedkoopInkopenChinaPage /> },
  { path: "/private-label-china", element: <PrivateLabelChinaPage /> },
  { path: "/sourcing-service", element: <SourcingServicePage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/geborduurde-tshirts-inkopen-china", element: <GeborduurdeShirtsPage /> },
  { path: "/blog/luxe-wandlampen-inkopen-china", element: <LuxeWandlampenPage /> },
  { path: "/blog/ev-laadkabels-inkopen-china", element: <EvLaadkabelsPage /> },
  { path: "/blog/bedrukte-paper-bags-inkopen-china", element: <BedruktePaperBagsPage /> },
  { path: "/blog/e-choppers-inkopen-china", element: <EChoppersPage /> },
  { path: "/blog/bedrukte-tissues-horeca-inkopen-china", element: <BedrukteTissuesPage /> },
  { path: "/blog/private-label-producten-china", element: <PrivateLabelProductenChinaPage /> },
  { path: "/blog/lage-moq-inkopen-china", element: <LageMoqInkopenChinaPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
